import dayjs from 'dayjs';
import moment from 'moment';
import jalaliday from 'jalaliday';
import { EQUIPMENT_OPTION_SORT } from '../../utils/constants';

dayjs.extend(jalaliday);

const calendar = localStorage.getItem('calendar') == 'Jalali' ? true : false;

export const DEFAULT_PAGINATION_LIMIT = 20;
export const DEFAULT_PAGINATION_PAGE = 1;
const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.000Z';

const startDate = calendar
  ? moment().locale('fa').startOf('day').format(DATE_FORMAT)
  : moment().startOf('day').format(DATE_FORMAT);

const endDate = calendar
  ? moment().locale('fa').endOf('day').format(DATE_FORMAT)
  : moment().endOf('day').format(DATE_FORMAT);

const dateWeek = [
  calendar ? dayjs.calendar('jalali').locale('fa') : dayjs(),
  calendar ? dayjs.calendar('jalali').locale('fa') : dayjs(),
];

const dateValue = [
  calendar
    ? moment(new Date(), 'YYYY-MM-DD').locale('fa')
    : moment(new Date(), 'YYYY-MM-DD'),
  calendar
    ? moment(new Date(), 'YYYY-MM-DD').locale('fa')
    : moment(new Date(), 'YYYY-MM-DD'),
];

export const DEFAULT_LOGS_STATE = {
  loading: false,
  info: {
    sort: 'DESC',
    limit: DEFAULT_PAGINATION_LIMIT,
    page: DEFAULT_PAGINATION_PAGE,
  },
  // startDate: "2024-02-26T00:00:00.000+03:30",
  // endDate: "2024-02-26T23:59:59.000+03:30",
  startDate: startDate,
  endDate: endDate,
  dateWeek: [dayjs(), dayjs()],
  dateValue: dateValue,
  sort: EQUIPMENT_OPTION_SORT.value,
  submit: false,
};

export const STATUS_CODE_OPTIONS = [
  { value: 200, label: '200' },
  { value: 201, label: '201' },
  { value: 400, label: '400' },
  { value: 401, label: '401' },
  { value: 403, label: '403' },
  { value: 404, label: '404' },
  { value: 500, label: '500' },
  { value: 501, label: '501' },
  { value: 503, label: '503' },
];
